module.exports = __webpack_public_path__ + "img/Vector_50_9113.3e1fce21.png";